import React from "react";
import { Button as MuiButton } from "@mui/material";
import styles from "./Button.module.css";

const Button = ({ variant, children, startIcon, className, ...props }) => {
  const getButtonClass = () => {
    switch (variant) {
      case "grey":
        return `${styles.default} ${styles.grey} ${className || ""}`;
      case "grey-light":
        return `${styles.default} ${styles.grey} ${styles.light} ${className || ""}`;
      case "outline":
        return `${styles.default} ${styles.outline} ${className || ""}`;
      case "outline-grey":
        return `${styles.default} ${styles.outlineGrey} ${className || ""}`;
      case "action":
        return `${styles.action} ${className || ""}`;
      default:
        return `${styles.default} ${styles.base} ${className || ""}`;
    }
  };

  return (
    <MuiButton className={getButtonClass()} startIcon={startIcon} {...props}>
      {children}
    </MuiButton>
  );
};

export default Button;
